import Box from "@mui/material/Box"

import Container from "@components/container"
import BaseLayout from "@layouts/base_layout"

import styles from "./styles"

const PassThrough = ({
  children
}: {
  children: JSX.Element | JSX.Element[]
}) => <>{children}</>

export default function MainLayout({
  children,
  HeaderComponent,
  ContextProvider = PassThrough,
  bgColor,
  LeftDrawer,
  RightDrawer
}: {
  children: JSX.Element | JSX.Element[]
  HeaderComponent?: () => JSX.Element
  ContextProvider?: (props: {
    children: JSX.Element | JSX.Element[]
  }) => JSX.Element
  bgColor?: "primary" | "secondary"
  LeftDrawer?: () => JSX.Element
  RightDrawer?: () => JSX.Element
}) {
  return (
    <BaseLayout bgColor={bgColor}>
      <ContextProvider>
        <Box sx={styles.contextContainer}>
          {LeftDrawer ? <LeftDrawer /> : <></>}
          <Box sx={styles.contentAreaContainer}>
            {HeaderComponent ? <HeaderComponent /> : <></>}
            <Box
              sx={(theme) => ({
                width: "100%",
                overflow: "auto!important",
                flex: 1,
                flexGrow: 1,
                padding: theme.spacing(3),
                transition: theme.transitions.create("margin", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen
                }),
                marginLeft: 0,
                p: 0
              })}
            >
              <Container>{children}</Container>
            </Box>
          </Box>
        </Box>
        {RightDrawer ? <RightDrawer /> : <></>}
      </ContextProvider>
    </BaseLayout>
  )
}
